<script>
  import { onMount } from "svelte";
  import * as ss from "simple-statistics";
  export let map;
  import { radioCheck, topZonesStore } from "../store.js";

  onMount(() => {});
  function systematicSample(data, interval) {
    return data.filter((_, index) => index % interval === 0);
  }

  function downsampleIfNeeded(data, threshold = 5000) {
    if (data.length > threshold) {
      let sampleSize = 1000;
      const interval = Math.floor(data.length / sampleSize);
      return systematicSample(data, interval);
    }
    return data;
  }

  function handleOptionChange(event) {
    console.log(event.target.value);
    if (
      event.target.value == "demandNorm" ||
      event.target.value == "needNorm"
    ) {
      console.log("hi");
      reset();
    } else {
      if (!map.getLayer("box-layer")) {
        return;
      }
      map.removeLayer("box-layer");
      map.addLayer(
        {
          id: "box-layer",
          type: "fill",
          source: "box",
          paint: {
            "fill-opacity": 0.8,
            "fill-color": [
              "interpolate",
              ["linear"],
              ["get", `${event.target.value}`],
              0,
              "#af0505",
              3.5,
              "yellow", // Red color at lower end
              7,
              "green", // Green color at higher end
            ],
          },
        },
        "tunnel-path-trail"
      );
    }
  }
  function reset() {
    if (map.getLayer("box-layer")) {
      map.removeLayer("box-layer");
      var data = map.getSource("box")._data.features;

      const values = data.map((obj) => obj.properties[$radioCheck]);

      let sortedValues = values.sort((a, b) => a - b);
      sortedValues = downsampleIfNeeded(sortedValues);

      var jenks = ss.jenks(sortedValues, 4);

      map.addLayer(
        {
          id: "box-layer",
          type: "fill",
          source: "box",
          paint: {
            "fill-opacity": 0.8,
            "fill-color": [
              "interpolate",
              ["linear"],
              ["get", `${$radioCheck}`],
              0,
              "#af0505",
              jenks[1],
              "orange",
              jenks[2],
              "yellow",
              jenks[3],
              "lightgreen",
              jenks[4],
              "green",
            ],
          },
        },
        "tunnel-path-trail"
      );
    }
  }
</script>

{#if $radioCheck == "demandNorm"}
  <div class="modelChoiceDemand">
    <select name="model" id="model" on:change={handleOptionChange}>
      <option value="" disabled selected>Select a demand input</option>
      <option value="demandNorm">All inputs combined</option>
      <option value="ptalNorm">High PTAL</option>
      <option value="popNorm">High Population</option>
      <option value="jobsNorm">High Employment</option>
      <option value="readinesslevel">Potential micromobility adopters</option>
      <!-- <option value="lessthan10kmNorm">Less than 10km commute</option>
      <option value="bikewalktoworkNorm">Cycling & Walking to work</option>
      <option value="age_15_45Norm">Age between 15 - 45</option>-->
    </select>
  </div>
{:else}
  <div class="modelChoiceDemand">
    <select name="model" id="model" on:change={handleOptionChange}>
      <option value="" disabled selected>Select a need input</option>
      <option value="needNorm">All inputs combined</option>
      <option value="ptal_rev_Norm">Low PTAL</option>
      <option value="popNorm">High Population</option>
      <option value="jobsNorm">High Employment</option>
      <option value="lessthan10kmNorm">Potential micromobility adopters</option>
    </select>
  </div>
{/if}

<style>
  .modelChoiceDemand {
    position: relative;
    top: 0px;
    font-size: 12px;
    margin: 15px;
    text-align: left;
  }
</style>
